export const STATION_GROUP_JOE = 'joe_fm';
export const STATION_GROUP_QMUSIC = 'qmusic_be';

export default {
  namespaced: true,
  state: {
    stationId: window.Site.stationId,
  },
}
